import { PaginatedResponse } from './PaginatedResponse';
import { OrgUser } from './SqspUser';

export enum SchedulingInstancePermission {
  'OWNER' = 'owner',
  'ADMIN' = 'admin',
  'VIEW' = 'view',
  'EDIT' = 'edit',
}

export interface SchedulingInstance {
  id: number;
  instanceName: string;
  userCount: number;
  calendarCount: number;
  dateCreated: string;
  permissions?: SchedulingInstancePermission;
  clientUrl: string;
  adminUrl: string;
}

export interface SchedulingInstancePermissionData {
  allowExports: boolean;
  calendars: number[];
  permissions: SchedulingInstancePermission;
  allCalendars: boolean;
  schedulingInstanceId?: number;
}

export interface SchedulingInstanceCalendar {
  id: number;
  name: string;
}

export interface SchedulingInstanceData {
  businessName: string;
  subdomain?: string;
}

export interface SchedulingInstanceFetchSingleResponse {
  data: SchedulingInstance;
}
export interface SchedulingInstanceFetchResponse extends PaginatedResponse {
  data: SchedulingInstance[];
}

export interface SchedulingInstanceCalendarResults extends PaginatedResponse {
  data: SchedulingInstanceCalendar[];
}

export interface SchedulingInstanceUsersFetchResponse extends PaginatedResponse {
  data: OrgUser[];
}
